<script>
import isEqual from 'lodash/isEqual';
import ComponentBase from '../component-base';
import { component } from './props';
export default {
    name: component,
    extends: ComponentBase,
    data() {
        return {
            // eslint-disable-next-line no-undefined
            value: undefined,
        };
    },
    methods: {
        /**
         * 以下是组件公共方法的实现
         */
        // 覆盖公共依赖处理方法，api的依赖处理直接是发一次请求
        dataChangeHandler() {
            const newValue = this.getSelfFormDataValue();
            // API组件没有默认值
            if (!isEqual(this.value, newValue)) {
                this.value = newValue;
                // 数据被动修改同样抛出change事件
                this.$emit('change');
            }
        },
    },
    render(h) {
        return h();
    },
};
</script>
